import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  isRolesLoading: false,
  isUsersLoading: false,
  isModulesLoading: false,
  isUserStatusesLoading: false,
  isPlansLoading: false,
  isPaymentMethodLoading: false,
  isSubscriptionStatusLoading: false,
  isTransactionLoading: false,
  isPromoCodeLoading: false,
  isSubjectTypeLoading:false,
  subjects:null,
  error: null,
  promoCodes: null,
  users: null,
  roles: null,
  modules: null,
  userstatuses: null,
  plans: null,
  paymentmethod: null,
  subscriptionstatus: null,
  transaction: null,
  permissions: []
};

const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    startRolesLoading(state) {
      state.isRolesLoading = true;
    },
    startUsersLoading(state) {
      state.isUsersLoading = true;
    },
    startModulesLoading(state) {
      state.isModulesLoading = true;
    },
    startUserStatusesLoading(state) {
      state.isUserStatusesLoading = true;
    },
    startPlansLoading(state) {
      state.isPlansLoading = true;
    },
    startPaymentMethodLoading(state) {
      state.isPaymentMethodLoading = true;
    },
    startSubscriptionStatusLoading(state) {
      state.isSubscriptionStatusLoading = true;
    },
    startTransactionLoading(state) {
      state.isTransactionLoading = true;
    },
    startPromoCodeLoading(state) {
      state.isPromoCodeLoading = true;
    },
    startSubjectTypeLoading(state){
      state.isSubjectTypeLoading =true;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isRolesLoading = false;
      state.isUsersLoading = false;
      state.isModulesLoading = false;
      state.isUserStatusesLoading = false;
      state.isPlansLoading = false;
      state.isPaymentMethodLoading = false;
      state.isSubscriptionStatusLoading = false;
      state.isTransactionLoading = false;
      state.isPromoCodeLoading = false;
      state.isSubjectTypeLoading = false;
      state.error = action.payload;
    },
    // SET ROLES
    setRoles(state, action) {
      state.isRolesLoading = false;
      state.roles = action.payload;
    },
    // SET USERS
    setUsers(state, action) {
      state.isUsersLoading = false;
      state.users = action.payload;
    },
    // SET MODULES
    setModules(state, action) {
      state.isModulesLoading = false;
      state.modules = action.payload;
    },
    // SET USERSTATUS
    setUserStatuses(state, action) {
      state.isUserStatusesLoading = false;
      state.userstatuses = action.payload;
    },
    // SET PLANS
    setPlans(state, action) {
      state.isPlansLoading = false;
      state.plans = action.payload;
    },
    // SET PAYMENTMETHOD
    setPaymentMethod(state, action) {
      state.isPaymentMethodLoading = false;
      state.paymentmethod = action.payload;
    },
    // SET SUBSCRIPTIONSTATUS
    setSubscriptionStatus(state, action) {
      state.isSubscriptionStatusLoading = false;
      state.subscriptionstatus = action.payload;
    },
    // SET PROMOCODE
    setPromoCodes(state, action) {
      state.isPromoCodeLoading = false;
      state.promoCodes = action.payload
    },
    //SET TRANSACTION
    setTransaction(state, action) {
      state.isTransactionLoading = false;
      state.transaction = action.payload;
    },
    // SET PERMISSIONS
    setPermissions(state, action) {
      state.permissions = action.payload
    },
    // SET SUBJECT TYPE 
    setSubjects(state, action){
      state.subjects = action.payload
    }
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  startLoading,
  startRolesLoading,
  startUsersLoading,
  startModulesLoading,
  startUserStatusesLoading,
  startPlansLoading,
  startPaymentMethodLoading,
  startSubscriptionStatusLoading,
  startTransactionLoading,
  startPromoCodeLoading,
  startSubjectTypeLoading,
  hasError,
} = slice.actions;

// ----------------------------------------------------------------------

export function getAuthUserPermissions() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/admin/auth/permissions');
      dispatch(slice.actions.setPermissions(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getRoles(params = {}) {
  return async () => {
    dispatch(slice.actions.startRolesLoading());
    try {
      const response = await axios.get('/dropdown/user/roles', { params: params });
      dispatch(slice.actions.setRoles(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getUsers() {
  return async () => {
    dispatch(slice.actions.startUsersLoading());
    try {
      const response = await axios.get('/dropdown/user/users');
      dispatch(slice.actions.setUsers(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getUserStatuses() {
  return async () => {
    dispatch(slice.actions.startUserStatusesLoading());
    try {
      const response = await axios.get('/dropdown/user/user_statuses');
      dispatch(slice.actions.setUserStatuses(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPlans() {
  return async () => {
    dispatch(slice.actions.startPlansLoading());
    try {
      const response = await axios.get('/dropdown/user/plans');
      dispatch(slice.actions.setPlans(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPromoCodes() {
  return async () => {
    dispatch(slice.actions.startPromoCodeLoading());
    try {
      const response = await axios.get('/dropdown/user/promo_codes');
      dispatch(slice.actions.setPromoCodes(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPaymentMethod() {
  return async () => {
    dispatch(slice.actions.startPaymentMethodLoading());
    try {
      const response = await axios.get('/dropdown/user/payment_methods');
      dispatch(slice.actions.setPaymentMethod(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getSubscriptionStatus() {
  return async () => {
    dispatch(slice.actions.startSubscriptionStatusLoading());
    try {
      const response = await axios.get('/dropdown/user/subscription_statuses');
      dispatch(slice.actions.setSubscriptionStatus(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getTransaction() {
  return async () => {
    dispatch(slice.actions.startTransactionLoading());
    try {
      const response = await axios.get('/admin/user/transactions');
      dispatch(slice.actions.setTransaction(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getSubjectList() {
  return async () => {
    dispatch(slice.actions.startSubjectTypeLoading());
    try {
      const response = await axios.get('/dropdown/user/activity_log_subject_types');
      dispatch(slice.actions.setSubjects(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}